import { InputField, FieldError } from '@estee/elc-inputs';
import * as React from 'react';
import { IFieldProps } from './Field';
import { observer } from 'mobx-react';

export interface IInputProps {
    inputLabel: string;
    hasAlert?: boolean;
    hasValidCheck?: boolean;
    isRequired: boolean;
    readOnly?: boolean;
    dataTestId: string;
    customClassName?: string;
    customLabelClassName?: string;
    inputType?: string;
    maxLength?: number;
    disabled?: boolean;
    showPasswordLabel?: string;
    showPasswordDataTestId?: string;
    id?: string;
    errorId?: string;
    ariaDescribedBy?: string;
    isAutoCompleteDisabled?: boolean;
    autoComplete?: string;
    inputMode?: string;
    list?: string;
    ariaLabel?: string;
    onInputFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onInputBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onInput?: React.FormEventHandler<HTMLInputElement> | undefined;
}

export const FormInput = observer((props: IInputProps & IFieldProps) => {
    const {
        disabled,
        form,
        field,
        inputType,
        inputLabel,
        customClassName,
        customLabelClassName,
        isRequired,
        hasAlert,
        hasValidCheck,
        readOnly,
        dataTestId,
        maxLength,
        showPasswordLabel,
        showPasswordDataTestId,
        id,
        isAutoCompleteDisabled,
        autoComplete,
        inputMode,
        list,
        ariaLabel,
        ariaDescribedBy,
        errorId,
        onInputBlur,
        onInputFocus,
        onInput
    } = props;
    const errorMessage = form.getError(field.name);
    const value = form.values[field.name];

    const fieldErrorId = errorId || (id ? `${id}_field_error` : undefined);

    const describedById = ariaDescribedBy || fieldErrorId;

    return (
        <div>
            <InputField
                name={field.name}
                id={id}
                inputType={inputType}
                inputValue={value}
                hasError={Boolean(errorMessage)}
                onBlur={field.onBlur}
                onFocus={field.onFocus}
                inputLabel={inputLabel}
                hasAlert={hasAlert}
                hasValidCheck={hasValidCheck}
                customClassName={customClassName}
                customLabelClassName={customLabelClassName}
                isRequired={isRequired}
                readOnly={readOnly}
                onChange={field.onChange}
                dataTestId={dataTestId}
                maxLength={maxLength}
                disabled={disabled}
                showPasswordLabel={showPasswordLabel}
                showPasswordDataTestId={showPasswordDataTestId}
                isAutoCompleteDisabled={isAutoCompleteDisabled}
                autoComplete={autoComplete}
                inputMode={inputMode}
                list={list}
                ariaLabel={ariaLabel}
                ariaDescribedBy={describedById}
                autoFocus={field.autoFocus}
                onInputFocus={onInputFocus}
                onInputBlur={onInputBlur}
                onInput={onInput}
            />
            <FieldError id={fieldErrorId} errorMessage={errorMessage} />
        </div>
    );
});
